import { useApolloClient, useMutation } from '@apollo/react-hooks';
import { ApiErrorCode } from '../../common/constants';
import { displaySnackBar } from '../../common/displaySnackbar';
import { CREATE_USER } from '../../graphql/user/mutation';
import {
  CreateUser,
  CreateUserVariables,
} from '../../graphql/user/types/CreateUser';
const PARRAINAGE_MISSED = 'PARRAINAGE CONNECTCRÉDIT INTROUVABLE';
export const useCreateUser = () => {
  const client = useApolloClient();
  return useMutation<CreateUser, CreateUserVariables>(CREATE_USER, {
    onError: (error) => {
      let message = 'Erreur inconnue';
      const currentError = error.graphQLErrors[0];
      if (currentError.extensions && currentError.extensions.code) {
        if (currentError?.message === PARRAINAGE_MISSED) {
          message = 'Parrainage connectCrédit introuvable';
        }
        switch (currentError.extensions.code) {
          case ApiErrorCode.ALREADY_EXIST:
            if (currentError.extensions.key === 'email') {
              message =
                "L'adresse email que vous avez spécifiée est déjà utilisée par un autre utilisateur";
            } else {
              message =
                'Le numéro de téléphone que vous avez spécifié est déjà utilisé par un autre utilisateur';
            }

            break;

          case ApiErrorCode.USER_NOT_FOUND:
            message =
              "L'expert Connectcrédit que vous avez choisi est introuvable.";
            break;

          case ApiErrorCode.SENDINBLUE_HOST_NOT_FOUND:
          case ApiErrorCode.MAIL_NOT_WAS_SENT:
            message =
              "Votre mail de vérification n'a pas pu être envoyé. Veuillez réessayer ulterieurement.";
            break;
          case ApiErrorCode.SMS_WAS_NOT_SENT:
            message =
              "Le SMS de vérification n'a pas pu être envoyé. Veuillez réessayer ulterieurement.";
            break;
        }
        displaySnackBar(client, {
          type: 'ERROR',
          message,
          isOpen: true,
        });
      }
    },
  });
};
